interface ISplitPhone {
    phoneArea: string;
    phone: string;
}

export const splitPhone = (
    phone: string | undefined,
    phonePrefixes: string[],
    defaultPhonePrefix: string,
): ISplitPhone => {
    const normalized = (phone ?? '').replace(/[\s-]/g, '');
    const match = phonePrefixes.find((prefix) => normalized.startsWith(prefix));

    return match
        ? { phoneArea: match, phone: normalized.slice(match.length) }
        : { phoneArea: defaultPhonePrefix, phone: normalized.replace(/^\+/, '') };
};
